<span
  class="field-hint"
  [class.field-hint--warn]="variant === 'warn'"
  [class.field-hint--start]="align === 'start'"
  [class.field-hint--wide]="wide"
  role="img"
  tabindex="0"
  [attr.data-hint]="text"
  [attr.aria-label]="accessibleLabel"
  (keydown.escape)="closeHint($event)"
  ><mat-icon class="field-hint__icon">{{ iconName }}</mat-icon></span
>
